export const capitalizeFirstLetter = (value: string): string =>
    value.charAt(0).toUpperCase() + value.slice(1)

export const roundNumber = (label: string | number, fractionDigits = 2): string | number => {
    const number = typeof label === 'number' ? label : parseFloat(label)
    return !isNaN(number) ? number.toFixed(fractionDigits) : label
}

export const isValidUrl = (str: string): boolean => {
    try {
        new URL(str)
        return true
    } catch {
        return false
    }
}
